import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ViewDidEnter, ViewWillEnter } from '@ionic/angular';
import { MenuItem, MenuSection } from 'src/app/models/rich-data.model';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-concierge',
  templateUrl: './concierge.component.html',
  styleUrls: ['./concierge.component.scss'],
})
export class ConciergeComponent implements OnInit, ViewDidEnter, ViewWillEnter {

  didInit = false;

  constructor(
    public dataServ: DataService,
    private router: Router,
    private titleService: Title
  ) { }

  ngOnInit() { }

    ionViewWillEnter(): void {
      this.titleService.setTitle('Concierge');
    }

  ionViewDidEnter() {
    this.didInit = false;

    setTimeout(() => {
      this.didInit = true;
    }, 100);
  }

  async detail(detailData: MenuItem, section: MenuSection): Promise<void> {
    this.dataServ.menuSection = section;
    this.dataServ.getItem(detailData.id);

    this.router.navigateByUrl(`/concierge/${section.id}/${detailData.id}`);
  }
}
